import {
  apiGET
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/cep.ts
var getCEPData = async ({ cep }) => {
  return apiGET(`/registration/cep/${cep}`);
};

export {
  getCEPData
};
